import * as React from "react";

import BaseDateRangeDropdown from "./base-date-range-dropdown.tsx";
import type {DateRangeProps} from "./types.ts";
import {transformDateRangeValue} from "./utils.ts";

/**
 * This date time range component will ensure that proper date
 * provided when making a selection in the dropdown. This component
 * will exclude time from the date range calculations!
 */
const DateRangeDropdown = (props: DateRangeProps) => {
    return (
        <BaseDateRangeDropdown
            transformValue={transformDateRangeValue}
            {...props}
        />
    );
};

export default React.memo(DateRangeDropdown);
